import $ from 'jquery';
import enquire from 'enquire.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import userPrefersReducedMotion from '../modules/userPrefersReducedMotion';
import { enableLinksInsideActiveSlides, disableLinksInInactiveSlides } from '../modules/flickityAccessibility';

Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

const ProjectsGalleryLite = () => {

  //   Projects Gallery Lite
  //--------------------------------------------------------------------
  const $projectsGalleryLite = $('.js-projects-gallery-lite');
  const $projectsGalleryLiteCarousel = $('.js-projects-gallery-lite-carousel');
  const $skipLink = $('.js-projects-gallery-lite-skip-link');
  const $toggleButton = $projectsGalleryLite.find('[data-toggle-button]');

  // Update skip link target based on layout
  const $thisSection = $skipLink.closest('.l-section');
  const $nextSection = $thisSection.next() ? $thisSection.next() : $('.site-footer');
  let targetId;

  if ($nextSection.length) {
    targetId = $nextSection.attr('id');

    if (!targetId) {
      targetId = `section-${Math.floor(Math.random() * 1000000)}`;
      $nextSection.attr('id', targetId);
    }

    $skipLink.attr('href', `#${targetId}`);
    $nextSection.attr('tabindex', '-1');
  }

  const carousels = [];

  $projectsGalleryLiteCarousel.each((index) => {
    const $row = $($projectsGalleryLiteCarousel[index])
    const rowReverse = index % 2 != 0
    const cellSelector = '.js-projects-gallery-lite-slide'

    $row.flickity({
      cellSelector: cellSelector,
      autoPlay: false,
      rightToLeft: rowReverse,

      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      selectedAttraction: 0.08,
      friction: 0.5,
      imagesLoaded: true,
      cellAlign: rowReverse ? 'right' : 'left',
      contain: true,
      on: {
        ready: function() {
          disableLinksInInactiveSlides(this);
          enableLinksInsideActiveSlides(this);
        },
        change: function() {
          disableLinksInInactiveSlides(this);
          enableLinksInsideActiveSlides(this);
        },
      }
    });

    carousels.push($row)

  })

  const playCarousels = () => {
    carousels.forEach(($carousel) => {
      if ($carousel && typeof $carousel.flickity === 'function') {
        $carousel.flickity('playPlayer')
      }
    })
  };

  const pauseCarousels = () => {
    carousels.forEach(($carousel) => {
      if ($carousel && typeof $carousel.flickity === 'function') {
        $carousel.flickity('pausePlayer')
      }
    })
  };

  // Set initial state based on user preference
  if (!userPrefersReducedMotion()) {
    setTimeout(() => {
      playCarousels();
    }, 1000)
    $toggleButton.find('[data-icon="play"]').hide();
    $toggleButton.attr('data-state', 'playing');
  } else {
    $toggleButton.find('[data-icon="pause"]').hide();
    $toggleButton.attr('data-state', 'paused');
  }


  // Toggle button functionality
  $toggleButton.on('click', function() {
    const buttonState = $(this).attr('data-state');
    const $icons = $(this).find('[data-icon]');
    $icons.hide();

    if (buttonState == 'playing') {
      pauseCarousels();
      $(this).find('[data-icon="play"]').show();
      $(this).attr('data-state', 'paused');
    } else if (buttonState == 'paused') {
      playCarousels();
      $(this).find('[data-icon="pause"]').show();
      $(this).attr('data-state', 'playing');
    }
  });

};

export default ProjectsGalleryLite;
